import React, { lazy } from "react";

export const VehicleManagementMetadata = {
  name: "Vehicle Management",
  id: "Vehicle_Management",
  component: lazy(() => import("../VehicleManagement/VehicleManagementPage")),
  route: "/connect360/vehicle_management",
  Breadcrumbs: true,
};
